import getConfig from 'next/config';

import { format } from '../utils';

import Service from './service';

// Import all Service function
export { AuthService } from './authService';
export { companyService } from './companyService';
export { jobService } from './jobService';
export { logActivity } from './logActivity';
export { loginWithThirdParty } from './loginService';
export { surveyService } from './surveyService';
export { uploadService } from './uploadService';

const {
  publicRuntimeConfig: { HttpRoutes },
} = getConfig();

export const fetchCompanies = (data) =>
  Service.get(format(HttpRoutes.getTopCompanies, data))
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));

export const fetchCompaniesCache = (data) =>
  Service.get(format(HttpRoutes.getTopCompaniesFromCache, data))
    .then((response) => Promise.resolve(response.data))
    .catch((error) => Promise.reject(error));

export const getJobs = (payload) => Service.post('api/jobs', payload);
